<template>
  <div class="article-list-item">
    <!-- 文章 -->
    <div class="top-box">
      <!-- 文章内容 -->
      <router-link
        :to="getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true)"
        :target="device.inApp ? '_blank' : '_self'"
      >
        <div class="text-box">
          <div class="title">
            <div class="left">
              <span :class="['tag', `tag-${item.type}`]">
                {{ typeActiveObj[item.type] }}
              </span>
              <span v-html="handleSummary(item.title)"></span>
            </div>
            <div class="right">
              <span class="has-img" v-if="item.thumb.length">
                <img src="@/assets/images/picture-icon.png" alt="" />
              </span>
            </div>
          </div>
          <div class="summary" v-if="item.type != 17" v-html="handleSummary(item.summary)"></div>
        </div>
      </router-link>
    </div>
    <!-- 文章数据 -->
    <div class="bottom-box">
      <div class="user-box" @click="goUserPage(item.user)">
        <img class="avatar" v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
        <div class="username">
          {{ item.user.username }}
        </div>
      </div>
      <div class="data-box">
        <div class="comment" @click.stop="onJumpComment(item)">
          <img class="icon" src="@/assets/images/replay-icon.png" alt="" />
          {{ item.comment_count }}
        </div>
        <div class="dot"></div>
        <div class="date">
          {{ dayjs(item.updated_at * 1000).fromNow() }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { apiContentLike } from "@/api/contentApi";
import { newDebounce, getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "articleListItem",
  mixins: [],
  props: {
    // 图片与标题布局  row, column
    layout: {
      type: String,
      default: "row"
    },
    item: {
      type: Object,
      default: () => {}
    },
    keyword: {
      type: String,
      default: ""
    },
    showUser: {
      type: Boolean,
      default: true
    },
    showGame: {
      type: Boolean,
      default: false
    },
    isUserHome: {
      type: Boolean,
      default: false
    }
  },
  model: {},
  components: {},
  data() {
    return {
      typeActive: [
        {
          type: "4",
          name: this.$t("posts")
        },
        {
          type: "15",
          name: this.$t("strategy")
        },
        {
          type: "2",
          name: this.$t("notices")
        },
        {
          type: "1",
          name: this.$t("entrys")
        },
        {
          type: "17",
          name: this.$t("question")
        },
        {
          type: "",
          name: this.$t("all")
        }
      ],
      tagInfos: {
        3: "工会",
        4: "交友",
        5: "攻略",
        6: "提问"
      }
    };
  },
  computed: {
    isShowTag() {
      return val => {
        return val == 3 || val == 4 || val == 5 || val == 6;
      };
    },
    typeActiveObj() {
      return this.typeActive.reduce((acc, cur) => {
        acc[cur.type] = cur.name;
        return acc;
      }, {});
    }
  },
  methods: {
    dayjs,
    getJumpWikiDetailUrl,
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    // 服务端渲染，替代getContentImgs
    getContentImgs(str = "") {
      const patten = /<img[^>]+src=['"]([^'"]+)['"]+/g;
      let imgs = [];
      let temp = null;
      while ((temp = patten.exec(str)) != null) {
        imgs.push(temp[1]);
      }
      return imgs && imgs.length ? imgs : null;
    },
    goUserPage(user) {
      window.open(`/user/index/${user.uid}.html`);
    },
    onClick(e) {
      if (this.isUserHome) {
        e.stopPropagation();
        e.preventDefault();
        // let url = `//${this.item.game.alias}.gamekee.com/${this.item.id}.html`;
        // window.open(url);
      }
    },
    // handleArticle (item) {
    //   this.$router.push(`/${item.id}.html`, this.device.inApp ? '_blank' : '_self');
    // },
    // goPage (item) {
    //   if (this.device.inApp) {
    //     this.jsToApp('app_goDetail', JSON.stringify(item));
    //   } else {
    //     this.$router.push(`/${item.id}.html`);
    //   }
    // },
    handleSummary(text) {
      let str = text;
      if (this.keyword) {
        let reg = new RegExp(`${this.keyword}`, "gim");
        str = text.replace(reg, '<span style="color:#FF6E6E;">' + this.keyword + "</span>");
      }
      return str;
    },
    onLike: newDebounce(
      function(articleItem) {
        // if (!this.isLogin()) {
        //   return false;
        // }
        let params = {
          is_like: articleItem.is_like ? 0 : 1,
          origin_id: articleItem.id,
          type: 1
        };
        apiContentLike(params).then(res => {
          articleItem.is_like = params.is_like;
          if (params.is_like) {
            articleItem.like_count++;
          } else {
            articleItem.like_count--;
          }
        });
      },
      500,
      true
    ),
    onJumpComment(item) {
      const path = getJumpWikiDetailUrl(
        item.game_alias || item.game.alias,
        item.game_id || item.game.id,
        item.id,
        true
      );
      sessionStorage.setItem("jumpDetailAnchorId", "detail-comment-ancher");
      this.$router.push(path);
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.article-list-item {
  margin-bottom: 24px;
  padding-bottom: 14px;
  display: block;
  border-bottom: 1px solid #e9e9e9;

  .top-box {
    margin-bottom: 10px;
    .text-box {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        font-size: 16px;
        color: #171717;
        line-height: 22px;
        margin-bottom: 10px;
        .left {
          display: flex;
          align-items: center;
        }
        .right {
          display: flex;
          align-items: center;
        }
        .tag {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 18px;
          margin-right: 8px;
          padding: 0 6px;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 12px;
          line-height: 18px;
          border: 1px solid transparent;
        }
        .tag-17 {
          color: #eea12b;
          border-color: #eea12b;
        }
        .tag-4 {
          color: #397eb5;
          border-color: #397eb5;
        }
        .tag-15 {
          color: #6dab64;
          border-color: #6dab64;
        }
        .tag-2 {
          color: #e0c35b;
          border-color: #e0c35b;
        }
        .tag-1 {
          color: #6e78ff;
          border-color: #6e78ff;
        }

        .has-img {
          display: inline-block;
          width: 20px;
          height: 20px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .summary {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }

  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    color: #575757;
    font-size: 12px;

    .user-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      .avatar {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        border-radius: 50%;
      }

      .username {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
    }

    .data-box {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      .comment {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;

        .icon {
          width: 14px;
          height: 14px;
          margin-top: 3px;
        }
      }
      .dot {
        width: 2px;
        height: 2px;
        background: #d8d8d8;
        border: 1px solid #979797;
      }
    }
  }
}
</style>
